
$(function () {

    // Fires a new event called 'fileWasSelected' when the file change
    $(document).on('change', 'input:file', function () {
        var input = $(this);
        var label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
        
        input.trigger('fileWasSelected', [label]);
    });

    // Set the label of the uploaded file
    
    $(document).on('fileWasSelected', 'input:file', function (_event, label) {
        $(this).closest('.uploaded-file-group')
               .find('.uploaded-file-name')
               .val(label);
    });
    
    $('.phone').text(function (_i, text) {
        return text.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    });
    
    var url = document.location.toString();
    if (url.match('#')) {
        var tabId = url.split('#')[1];
        $('.nav-tabs a[href="#' + tabId + '"]').tab('show');
    }

    // Change hash for page-reload
    $('.nav-tabs a').on('shown.bs.tab', function (e) {
        window.location.hash = e.target.hash;
    });

    $('select:not(".allow-default-selection") option[value=""]').attr('disabled', true)
                                                                .attr('hidden', true);

    // Increase the font size
    $('.up').click(function () {
        var field = '#' + $(this).attr('id').replace('-up', '');
        curSize = parseInt($(field).css('font-size')) + 2;
        if (curSize <= 24)
            $(field).css('font-size', curSize);
    });

    // Decrease the font size
    $('.down').click(function (_index, _item) {
        var field = '#' + $(this).attr('id').replace('-down', '');
        curSize = parseInt($(field).css('font-size')) - 2;
        if (curSize >= 8)
            $(field).css('font-size', curSize);
    });

    // Change div text with input field
    $('.form-keyin').keyup(function () {
        var field = '#' + $(this).attr('id').replace('-text', '');
        var keyed = $(this).val().replace(/\n/g, '<br />');
        $(field).html(keyed);
    });

});
